import ToggleItem, { ToggleItemProps } from './ToggleItem';

export type { ToggleItemProps };
export default ToggleItem;
